import React from 'react';
import ReactDOM from 'react-dom';
import App from '~/App';
import DarkModeProvider from './common/contexts/darkMode';

ReactDOM.render(
  <DarkModeProvider>
    <App />
  </DarkModeProvider>, document.getElementById('root'));
